import { render, staticRenderFns } from "./CreationBoutique.vue?vue&type=template&id=54451134&scoped=true&"
import script from "./CreationBoutique.vue?vue&type=script&lang=js&"
export * from "./CreationBoutique.vue?vue&type=script&lang=js&"
import style0 from "./CreationBoutique.vue?vue&type=style&index=0&id=54451134&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54451134",
  null
  
)

export default component.exports